import { useLocation } from "react-router-dom";
import { LogOut, Menu } from "lucide-react";

const SEGMENT_LABEL = {
  dashboard: "Dashboard",
  inbox: "Inbox",
  kanban: "Kanban",
  tasks: "Aufgaben",
  calendar: "Kalender",
  settings: "Einstellungen",
};

export default function JourneyTopbar({ onLogout, onOpenMobileNav }) {
  const { pathname } = useLocation();
  const seg = pathname.split("/").filter(Boolean).pop() || "dashboard";
  const label = SEGMENT_LABEL[seg] || "Journey Control";

  return (
    <header
      data-testid="journey-topbar"
      className="flex h-14 items-center justify-between border-b border-white/5 bg-[#050607]/95 px-4 backdrop-blur md:px-6"
    >
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onOpenMobileNav}
          aria-label="Navigation öffnen"
          data-testid="journey-mobile-nav-toggle"
          className="-ml-2 rounded p-2 text-zinc-400 transition hover:bg-white/5 hover:text-zinc-100 lg:hidden"
        >
          <Menu className="h-5 w-5" />
        </button>
        <div className="flex items-baseline gap-2">
          <span className="text-[11px] uppercase tracking-[0.18em] text-zinc-500">
            Journey
          </span>
          <span className="text-sm font-medium text-zinc-100">{label}</span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <span
          data-testid="journey-user-badge"
          className="hidden text-xs text-zinc-400 sm:inline"
        >
          Marcel / Admin
        </span>
        <button
          type="button"
          onClick={onLogout}
          data-testid="journey-logout"
          className="inline-flex items-center gap-1.5 rounded border border-white/10 px-2.5 py-1.5 text-xs text-zinc-300 transition hover:border-white/20 hover:bg-white/5"
        >
          <LogOut className="h-3.5 w-3.5" />
          Abmelden
        </button>
      </div>
    </header>
  );
}
